<template>
  <div
    class="popup-content"
    :style="{ zIndex: index }"
  >
    <select-color
      :types="types"
      :info="info"
      :update-info="updateInfo"
      @close="closePopup"
    ></select-color>
  </div>
</template>
<script>
export default {
  name: 'PopupContent',
  components: {
    SelectColor: () => import('@/components/popups/selectColor.vue')
  },
  data() {
    return {
      index: 200,
      info: {},
      types: [],
      updateInfo: 0
    };
  },
  mounted() {
    this.$bus.on('popup_show', this.showPopup);
    this.$bus.on('popup_close', this.closePopup);
    document.addEventListener('mousedown', this.mousedown);
  },
  methods: {
    showPopup(data) {
      if (!data.type) return;
      if (this.types.indexOf(data.type) < 0) {
        this.types.push(data.type);
        this.info[data.type] = data.info;
      } else {
        this.info[data.type] = data.info;
        this.updateInfo++;
      }
    },
    closePopup(data) {
      if (data.type === 'all') {
        this.types = [];
        this.info = {};
      } else if (data.type) {
        let index = this.types.indexOf(data.type);
        if (index > -1) {
          this.types.splice(index, 1);
          this.info[data.type] = null;
        }
      }
    },
    mousedown() {
      if (this.types.length) {
        this.closePopup({ type: 'all' });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.popup-content {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 24;

  > div {
    position: absolute;
    background: #ffffff;
    box-shadow: 0px 2px 16px 0px rgba(56, 58, 66, 0.24);
    border-radius: 4px;
  }
}
</style>
